module.exports = __webpack_public_path__ + "static/BISAM-38303daf18da28145716120ee68dc527.png";